module.exports = __webpack_public_path__ + "media/images/logos/google-354293dfea86a26301c1d62b7554005e.svg";